import { createReducer, on } from '@ngrx/store';

import { mainPageAction } from './main-page.actions';
import { UrgentAnnouncement } from '../../models/main-page.model';
import { ShiftSchedule } from '../../models/shift-schedule.model';

export interface MainPageState {
  summaryData: any;
  notificationData: any;
  dailyWorkInstructionData: any;
  membershipSummaryData: any;
  shiftScheduleData: ShiftSchedule[];
  dashboardData: any;
  urgentAnnouncementData: UrgentAnnouncement | null;
}

export const initialState: MainPageState = {
  summaryData: null,
  notificationData: null,
  dailyWorkInstructionData: null,
  membershipSummaryData: null,
  shiftScheduleData: null,
  dashboardData: null,
  urgentAnnouncementData: null
};

export const MainPageReducer = createReducer<MainPageState>(
  initialState,
  on(mainPageAction.notificationResponse, (state, response) => {
    return { ...state, notificationData: response };
  }),
  on(mainPageAction.summaryResponse, (state, response) => {
    return { ...state, summaryData: response };
  }),
  on(mainPageAction.membershipSummaryResponse, (state, response) => {
    return { ...state, membershipSummaryData: response };
  }),
  on(mainPageAction.shiftScheduleResponse, (state, { data }) => {
    return { ...state, shiftScheduleData: data };
  }),
  on(mainPageAction.dashboardOverviewResponse, (state, response) => {
    return { ...state, dashboardData: response };
  }),
  on(mainPageAction.urgentAnnouncementResponse, (state, { data }) => {
    return { ...state, urgentAnnouncementData: data };
  }),
  on(mainPageAction.resetData, (state) => {
    return {
      ...state,
      summaryData: null,
      notificationData: null,
      dailyWorkInstructionData: null,
      membershipSummaryData: null,
      shiftScheduleData: null,
      dashboardData: null,
      urgentAnnouncementData: null
    };
  })
);
